<template>
  <el-dialog
    :title="isEdit?'编辑':'新增'"
    :visible.sync="visible"
    :append-to-body="true"
    @close="handleClose"
    width="400px">
    <el-form  ref="form" v-model="form">
      <el-form-item label="区域名称">
          <el-input placeholder="请输入区域名称" v-model="form.description" style="width:200px"></el-input>
      </el-form-item>
      <el-form-item label="创建人">
          {{form.createPerson}}
      </el-form-item>
      <el-form-item label="创建时间">
          {{form.createTime}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button  @click="save()">保存</el-button>
    </div>
 </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'editDialog',
  props: ['show', 'info', 'isEdit'],
  data () {
    return {
      visible: this.show,
      form: {
        description: '',
        creatUser: '',
        creatTime: ''
      },
      nowTime: ''
    }
  },
  methods: {
    ...mapActions(['addHandOrderAreas', 'getseveHandAreas']),
    // getLoginUser () {
    //   const userInfo = window.storage.getItem(window.storage.keys.USER_INFO)
    //   this.form.creatUser = userInfo.name
    // }
    getCurrentTime () {
      // 获取当前时间并打印
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let hh = new Date().getHours()
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      this.nowTime = yy + '/' + mm + '/' + dd + ' ' + hh + ':' + mf + ':' + ss
    },
    save () {
      var params = {}
      if (this.isEdit) {
        params = { id: this.info.id, areaName: this.form.description }
      } else {
        params = { areaName: this.form.description }
      }
      this.addHandOrderAreas(params).then(res => {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.$emit('addOrEditClose')
        this.handleClose()
      })
    },
    handleClose () {
      this.$refs['form'].resetFields()
      this.form = {
        description: '',
        createPerson: '',
        createTime: ''
      }
      this.$emit('update:show', false)
    }
  },
  created () {
  },

  mounted () {
  },

  watch: {
    show (newVal) {
      this.visible = newVal

      console.log(this.isEdit)
      console.log(this.info)
      if (this.isEdit) {
        // this.form = this.info
        Object.assign(this.form, this.info)
      } else {
        const userInfo = window.storage.getItem(window.storage.keys.USER_INFO)
        this.form.creatUser = userInfo.name
        this.getCurrentTime()
        this.form = {
          description: '',
          createPerson: userInfo.userName,
          createTime: this.nowTime
        }
      }
    },
    isEdit (newVal) {
      console.log(newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
